<template>
  <div>
    <!-- TODO: Maybe refactor and merge with GuestsResultsView -->
    <div v-if="!isLoaded" />
    <v-list
      v-else-if="reservationsByTime.size > 0"
      class="pt-0"
      two-line
    >
      <v-list-item-group
        v-model="selected"
        @change="selectedChange"
      >
        <template v-for="[group, value] in reservationsByTime.entries()">
          <guest-list-header-row
            :key="group"
            :title="$localized.hourMinTextFrom24hr(group)"
          />
          <template v-for="(reservation, i) in value">
            <guest-list-row
              :key="`fp_g_${group}_r_${i}`"
              :reservation="reservation"
              :overbooked-tab-items="overbookedTabItemsForReservation.get(reservation.id)"
              unread-reservations
              compact
            />
            <v-divider
              v-if="i + 1 < value.length"
              :key="`${group}_${i}`"
            />
          </template>
        </template>
      </v-list-item-group>
    </v-list>
    <template v-else>
      <div class="d-flex h-100 flex-column justify-center align-center">
        <div>{{ $t('placeholder.no_reservations') }}</div>
      </div>
    </template>
    <!-- END Refactor -->
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import Reservation from '@/model/Reservation';
import GuestListRow from '@/components/views/guests/GuestListRow.vue';
import GuestListHeaderRow from '@/components/views/guests/GuestListHeaderRow.vue';

export default Vue.extend({
  name: 'FloorplanViewSidebar',
  components: {
    GuestListRow, GuestListHeaderRow,
  },
  props: {
    reservationsByTime: { type: Object as PropType<Map<string, Reservation[]>>, required: true },
    selectedResId: { type: Number, required: false, default: undefined },
    isLoaded: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      selected: this.selectedResId,
    };
  },
  computed: {
    overbookedTabItemsForReservation(): Map<number, Set<number>|undefined> {
      return this.$tstore.getters.dayOverbookedTabItemsForReservationId;
    },
  },
  watch: {
    selectedResId() {
      this.selected = this.selectedResId;
    },
  },
  methods: {
    selectedChange(reservationId: number) {
      this.$emit('selected', reservationId);
    },
  },
});

</script>
